import BranchDto from "../Branches/BranchDto";

export default class CreateAgencyUserRequest  {
	firstName = '';  
	lastName = '';
    emailAddress = '';
	mobilePhoneNumber ='';
    otherPhoneNumber = '';
    defaultBranchId: string;
    defaultDeskId: string;
    isAdministrator = false;
    managerId: string;
}